module.exports = __webpack_public_path__ + "img/no-data.7e5bc048.png";